/**
 * Enum representing the possible operators used to compare different values for vital signs and lab results.
 */
enum CareElementOperatorType {
    None,
    GreaterThan,
    LessThan,
    GreaterThanOrEqualTo,
    LessThanOrEqualTo,
    EqualTo,
    Between
}

const CareElementOperatorTypeValue: Record<CareElementOperatorType, string | null> = {
    [CareElementOperatorType.None]: null,
    [CareElementOperatorType.GreaterThan]: ">",
    [CareElementOperatorType.LessThan]: "<",
    [CareElementOperatorType.GreaterThanOrEqualTo]: ">=",
    [CareElementOperatorType.LessThanOrEqualTo]: "<=",
    [CareElementOperatorType.EqualTo]: "=",
    [CareElementOperatorType.Between]: "BetweenLabel"
};

export { CareElementOperatorType, CareElementOperatorTypeValue };
